export const locale = {
    lang: 'tr',
    data: {
        'NAV': {
            'APPLICATIONS': 'Programlar',
            'SAMPLE'        : {
                'TITLE': 'Örnek',
                'BADGE': '15'
            }
        }
    }
};



// WEBPACK FOOTER //
// /vercel/path0/src/app/navigation/i18n/tr.ts